import { getModalityChartColor } from "@/lib/modalities";

const ModalityDotLabel = ({ modalityKey, label, truncate = true }) => {
  if (!modalityKey && !label) return null;

  return (
    <span className="inline-flex items-center gap-2 min-w-0">
      <span
        className="w-2.5 h-2.5 rounded-full shrink-0"
        style={{ backgroundColor: getModalityChartColor(modalityKey) }}
        aria-hidden
      />
      <span className={truncate ? "truncate" : "whitespace-nowrap"}>{label || modalityKey}</span>
    </span>
  );
};

export default ModalityDotLabel;
